import React from 'react';
import Input from 'react-phone-number-input/input';
import classNames from 'classnames';
import {Input as ReactstrapInput} from 'reactstrap';
import './PhoneNumberInput.scss';

const CustomPhoneNumberInput = React.forwardRef(({value, onChange, ...rest}, ref) => (
    <ReactstrapInput
        type="tel"
        innerRef={ref}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        {...rest}
    />
));

const PhoneNumberInput = ({
                              value,
                              onChange,
                              invalid,
                              disabled,
                              className,
                          }) => {
    return (
        <div className={classNames('phone-number-input-container', {className})}>
            <span className="country-code">+1</span>
            <Input
                country="US"
                defaultCountry="US"
                value={value}
                onChange={(value) => onChange(value || '')}
                className="phone-number-input"
                invalid={invalid}
                disabled={disabled}
                inputComponent={CustomPhoneNumberInput}
            />
        </div>
    );
};

export default PhoneNumberInput;


// WEBPACK FOOTER //
// ./src/common/form/PhoneNumberInput.js